import React, { useMemo } from 'react';
import { Container, Typography } from '@mui/material';

import DepositDetailCommonComponent from '../CommonComponent/DepositDetailCommonComponent';
import { Breadcrumbs } from '../../../components/shared';
import { routeConstants } from '../../../constants/routeConstants';
import BREADCRUMB_NAMES from '../../../constants/breadcrumbNames';
import { useParams } from 'react-router-dom';
import { useGetDepositsByIdQuery } from '../../../services/Deposit/DepositService';

const ApprovedDetailDeposit = () => {
  const params = useParams();
  const depositId = Number(params.id);
  const {
    DEPOSIT: { DEPOSIT, APPROVED_DETAIL },
  } = BREADCRUMB_NAMES;
  const { currentData: depositDetails, isError, error } = useGetDepositsByIdQuery(depositId);

  const breadcrumbData = useMemo(
    () => [
      {
        text: DEPOSIT,
        redirection: `${routeConstants.DEPOSIT_ROUTE}?selectedTab=3`,
      },
      { text: APPROVED_DETAIL },
    ],
    [],
  );

  if (isError)
    return (
      <Container maxWidth={'xl'} disableGutters>
        <Typography>{error.message}</Typography>
      </Container>
    );
  return (
    <Container maxWidth={'xl'} disableGutters>
      <Breadcrumbs variant="body2" underline="hover" data={breadcrumbData} />
      <DepositDetailCommonComponent isApproved depositDetails={depositDetails?.data} />
    </Container>
  );
};

export default ApprovedDetailDeposit;
